import { Directive, ElementRef, OnInit, Input } from '@angular/core';
import { ViewUpdateService } from '../../services/view-update.service';

@Directive({
    selector: '[appFlexColumnHeight]',
    standalone: false
})
export class FlexColumnHeightDirective implements OnInit {
  @Input() appFlexColumnHeight;
  constructor(
    private el: ElementRef,
    private viewUpdate: ViewUpdateService
  ) {}
  ngOnInit() {
    if (this.appFlexColumnHeight) {
      this.setHeight();
      this.viewUpdate.registerChangePropagation().subscribe(c => {
        this.setHeight();
        setTimeout(t => {
          this.setHeight();
        }, 2000);
      });
    }
  }
  setHeight() {
    //console.log('update height')
    var anc = this.findAncestor(this.el.nativeElement, '.flex-center');
    if (anc && anc.offsetHeight > 10) {
      this.el.nativeElement.style.height = 0;
      // console.log(anc);
      this.el.nativeElement.style.height = anc.offsetHeight - 1 + 'px';
      //console.log(this.el.nativeElement.style.height)
    }
  }

  findAncestor(el, sel) {
    while (
      (el = el.parentElement) &&
      !(el.matches || el.matchesSelector).call(el, sel)
    );
    return el;
  }
}
